import { Navigate, Route, Routes } from 'react-router-dom'
import { Spinner } from './components/ui'
import { Shell } from './layout/Shell'
import { useAuth } from './lib/auth'
import { Audit } from './screens/admin/Audit'
import { Imports } from './screens/admin/Imports'
import { GovernanceScreen, UpliftScreen } from './screens/admin/Rules'
import { Users } from './screens/admin/Users'
import { VersionEditor } from './screens/admin/VersionEditor'
import { Versions } from './screens/admin/Versions'
import { Landing } from './screens/Landing'
import { Login } from './screens/Login'
import { Operators } from './screens/platform/Operators'
import { TenantDetail } from './screens/platform/TenantDetail'
import { Tenants } from './screens/platform/Tenants'
import { PriceFinder } from './screens/rep/PriceFinder'
import { Quotes } from './screens/rep/Quotes'
import { EscalationDetail } from './screens/supervisor/EscalationDetail'
import { Queue } from './screens/supervisor/Queue'
import { TeamView } from './screens/supervisor/TeamView'

export function App() {
  const { loading, user, operator } = useAuth()
  if (loading) return <Spinner label="Signing in…" />
  if (operator) {
    return (
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<Navigate to="/platform/tenants" replace />} />
          <Route path="/platform/tenants" element={<Tenants />} />
          <Route path="/platform/tenants/:id" element={<TenantDetail />} />
          <Route path="/platform/operators" element={<Operators />} />
          <Route path="*" element={<Navigate to="/platform/tenants" replace />} />
        </Route>
      </Routes>
    )
  }
  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }
  const home = user.role === 'admin' ? '/admin/versions' : user.role === 'head' ? '/team' : user.role === 'supervisor' ? '/queue' : '/price'
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Navigate to={home} replace />} />
        {(user.role === 'rep' || user.role === 'supervisor') && (
          <>
            <Route path="/price" element={<PriceFinder />} />
            <Route path="/quotes" element={<Quotes />} />
            <Route path="/quotes/:id" element={<Quotes />} />
          </>
        )}
        {(user.role === 'supervisor' || user.role === 'head') && (
          <>
            <Route path="/queue" element={<Queue />} />
            <Route path="/queue/:id" element={<EscalationDetail />} />
          </>
        )}
        {(user.role === 'supervisor' || user.role === 'head') && <Route path="/team" element={<TeamView />} />}
        {user.role === 'admin' && (
          <>
            <Route path="/admin/versions" element={<Versions />} />
            <Route path="/admin/versions/:id" element={<VersionEditor />} />
            <Route path="/admin/uplift" element={<UpliftScreen />} />
            <Route path="/admin/governance" element={<GovernanceScreen />} />
            <Route path="/admin/import" element={<Imports />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/audit" element={<Audit />} />
          </>
        )}
        <Route path="*" element={<Navigate to={home} replace />} />
      </Route>
    </Routes>
  )
}
